import { FieldBase, ResellerItem } from '@vendasta/store';
import { Product } from '../../core/product/product';

export interface StatusMessage {
  text: string;
  type: 'warn' | 'info';
}

export interface ItemIdAndQuantity {
  quantity: number;
  appId?: string;
  addonId?: string;
  editionId?: string;
}

export type UniqueIdToItemIdAndQuantityMap = Map<string, ItemIdAndQuantity>;

export interface CommonFormSection {
  sectionName: string;
  fields: FieldBase<any>[];
  mdIconName: string; // For a list of mat-icons, visit https://material.io/icons/
}

export class ProductOrderForm extends Product {
  commonFields: CommonFormSection[];
  customFields: FieldBase<any>[];
  activationMessage: string;

  constructor(data: {
    product: Product;
    commonFields?: CommonFormSection[];
    customFields?: FieldBase<any>[];
    activationMessage?: string;
  }) {
    super(data.product);
    this.commonFields = data.commonFields || [];
    this.customFields = data.customFields || [];
    this.activationMessage = data.activationMessage || '';
  }
}

export class CommonFormGroup {
  section: CommonFormSection;
  data: any;

  constructor(section: CommonFormSection, data: any) {
    this.section = section;
    this.data = data;
  }
}

export class ResellerItemOrderForm extends ResellerItem {
  commonFields: CommonFormSection[];
  customFields: FieldBase<any>[];
  activationMessage: string;

  constructor(data: {
    product: ResellerItem;
    commonFields?: CommonFormSection[];
    customFields?: FieldBase<any>[];
    activationMessage?: string;
  }) {
    super(data.product);
    this.commonFields = data.commonFields || [];
    this.customFields = data.customFields || [];
    this.activationMessage = data.activationMessage || '';
  }
}
